import React, { Component } from "react";
import mixpanel from "../../lib/mixPanel";

import PostLogin from "./PostLogin";
import PreLogin from "./PreLogin";

export default class Home extends Component {
  render() {
    mixpanel.people.increment("Count of App Opens");
    const { user, authed } = this.props;
    return (
      ((authed || (user && user.uid)) && <PostLogin user={user} />) || (
        <PreLogin />
      )
    );
  }
}
